/**
 * Persistencia de preferencias de columnas por lista (orden, visibilidad).
 * Clave en localStorage: smarty:list-columns:{listId}:{tenantId}
 */

export interface ListColumnPreferences {
  columnOrder: string[];
  hiddenColumnKeys: string[];
}

const STORAGE_PREFIX = 'smarty:list-columns';

function storageKey(listId: string, tenantId: string | undefined): string {
  return tenantId ? `${STORAGE_PREFIX}:${listId}:${tenantId}` : '';
}

function isListColumnPreferences(obj: unknown): obj is ListColumnPreferences {
  return (
    obj != null &&
    typeof obj === 'object' &&
    Array.isArray((obj as ListColumnPreferences).columnOrder) &&
    Array.isArray((obj as ListColumnPreferences).hiddenColumnKeys)
  );
}

export function loadListColumnPreferences(
  listId: string,
  tenantId: string | undefined
): ListColumnPreferences | null {
  const key = storageKey(listId, tenantId);
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    return isListColumnPreferences(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function saveListColumnPreferences(
  listId: string,
  tenantId: string | undefined,
  prefs: ListColumnPreferences
): void {
  const key = storageKey(listId, tenantId);
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify(prefs));
  } catch {
    /* ignore */
  }
}
